import { change } from 'redux-form'
import {
  EYE_CONFIG,
  MULTIFOCAL_ONLY_SUFFIXES,
  PRESCRIPTION_FIELD_SUFFIXES,
  SPECTERA_CLAIM_FORM,
  isSingleVisionPrescription,
} from './constants'

export const getPrescriptionFieldName = (eyePrefix, suffix) => `${eyePrefix}_prescription_${suffix}`

export const getPrescriptionFieldPath = (eyePrefix, suffix) =>
  `lab_prescription.${EYE_CONFIG[eyePrefix].section}.${getPrescriptionFieldName(eyePrefix, suffix)}`

const OPPOSITE_EYE_PREFIX = {
  right: 'left',
  left: 'right',
}

const PRESCRIPTION_CLEARABLE_SUFFIXES = PRESCRIPTION_FIELD_SUFFIXES.filter((suffix) => suffix !== 'balance')

export const clearPrescriptionEyeFields = (dispatch, eyePrefix) => {
  PRESCRIPTION_CLEARABLE_SUFFIXES.forEach((suffix) => {
    dispatch(change(SPECTERA_CLAIM_FORM, getPrescriptionFieldPath(eyePrefix, suffix), ''))
  })
  dispatch(change(SPECTERA_CLAIM_FORM, getPrescriptionFieldPath(eyePrefix, 'balance'), false))
}

export const handleBalanceCheck = (dispatch, eyePrefix, isChecked) => {
  if (isChecked) {
    clearPrescriptionEyeFields(dispatch, OPPOSITE_EYE_PREFIX[eyePrefix])
  }
}

export const copyPrescriptionOuField = (dispatch, formValues, suffix) => {
  const sourceValue = formValues?.lab_prescription?.[EYE_CONFIG.right.section]?.[getPrescriptionFieldName('right', suffix)]
  dispatch(change(SPECTERA_CLAIM_FORM, getPrescriptionFieldPath('left', suffix), sourceValue ?? ''))
}

const OU_COPY_SUFFIXES = {
  singleVision: [
    'sphere',
    'cylinder',
    'axis',
    'distance_pd',
    'optical_center',
    'oc_reference',
    'base_curve',
    'horizontal_prism',
    'horizontal_base',
    'vertical_prism',
    'vertical_base',
  ],
  multifocal: [
    'sphere',
    'cylinder',
    'axis',
    'distance_pd',
    'near_pd',
    'addition',
    'segment_height',
    'optical_center',
    'oc_reference',
    'base_curve',
    'horizontal_prism',
    'horizontal_base',
    'vertical_prism',
    'vertical_base',
  ],
}

export const copyAllPrescriptionOuFields = (dispatch, formValues, isSingleVision) => {
  const suffixes = isSingleVision ? OU_COPY_SUFFIXES.singleVision : OU_COPY_SUFFIXES.multifocal
  suffixes.forEach((suffix) => copyPrescriptionOuField(dispatch, formValues, suffix))
}

export const clearMultifocalPrescriptionFields = (dispatch) => {
  ;['right', 'left'].forEach((eyePrefix) => {
    MULTIFOCAL_ONLY_SUFFIXES.forEach((suffix) => {
      dispatch(change(SPECTERA_CLAIM_FORM, getPrescriptionFieldPath(eyePrefix, suffix), ''))
    })
  })
}

export const clearPrescriptionSection = (dispatch) => {
  dispatch(change(SPECTERA_CLAIM_FORM, 'lab_prescription.prescription_lens_type', ''))

  ;['right', 'left'].forEach((eyePrefix) => {
    PRESCRIPTION_FIELD_SUFFIXES.forEach((suffix) => {
      const value = suffix === 'balance' ? false : ''
      dispatch(change(SPECTERA_CLAIM_FORM, getPrescriptionFieldPath(eyePrefix, suffix), value))
    })
  })
}

export const handlePrescriptionLensTypeChange = (dispatch, previousType, nextType) => {
  if (isSingleVisionPrescription(nextType) && !isSingleVisionPrescription(previousType)) {
    clearMultifocalPrescriptionFields(dispatch)
  }
}
